<template>
  <el-card shadow="never" class="aui-card--fill">
	  <el-row style="background-color: #F3F4F4;">
	  	<el-col :xs="24" :md="6" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
	  		<img style="width: 16px;height: 16px;margin-right: 12px;" src="../../../assets/img/user-list.png" />
	  		任务列表
	  	</el-col>
	  	<el-col :xs="24" :md="18">
	  		<el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" style="text-align: right;">
	  			<el-form-item>
	  				<el-button class="exportBtn" style="left: 615px;" type="primary" @click="exportHandle()">
	  					{{ $t('export') }}
	  				</el-button>
	  			</el-form-item>
	  			<el-form-item><el-button class="refreshBtn" style="left: 500px;" type="info" @click="getDataList()">刷新</el-button></el-form-item>
	  		</el-form>
	  	</el-col>
	  </el-row>
    <div class="mod-plat__plattask}">
      <el-form label-width="80px"  style="padding:10px 5px 0px;" ref="dataForm" :model="dataForm" @keyup.enter.native="getDataList()">
      		  <el-row>
      		  	<el-col :md="12" :lg="5">
      		  		<el-form-item label="发布方" prop="publishName">
      		  		  <el-input v-model="dataForm.publishName" style="width: 100%;" placeholder="发布方" clearable></el-input>
      		  		</el-form-item>
      		  	</el-col>
      		  	<el-col :md="12" :lg="5">
      		  		<el-form-item label="任务大类" prop="taskType">
      		  		  <ren-select v-model="dataForm.taskType" style="width: 100%;" dict-type="taskType" placeholder="任务大类"></ren-select>
      		  		</el-form-item>
      		  	</el-col>
      		  	<el-col :md="12" :lg="6">
      		  		<el-form-item class="pickerStyle" label="预算金额">
      		  		  <el-input v-model.number="dataForm.budget1" placeholder="预算金额" style="width: 48%;"></el-input>
      		  		  <span style="width:4%;text-align: center;display: inline-block;">~</span>
      		  		  <el-input v-model.number="dataForm.budget2" placeholder="预算金额" style="width: 48%;"></el-input>
      		  		</el-form-item>
      		  	</el-col>
      		  	<el-col :md="12" :lg="8">
      		  		<el-form-item class="pickerStyle" label="发布日期">
      		  		  <el-date-picker style="width:48%" v-model="dataForm.startDate" placeholder="开始时间" type="date" @change="formatStartTime" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
      		  		  <span style="width:4%;text-align: center;display: inline-block;">~</span>
      		  		  <el-date-picker style="width:48%" v-model="dataForm.endDate" placeholder="结束时间"  type="date" @change="formatEndTime" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>

      		  		</el-form-item>
      		  	</el-col>
      			<el-col :md="24" :lg="24">
      				<el-form-item>
      					<div style="text-align: right;">
      						<el-button type="primary" @click="getDataList()">{{ $t('query') }}</el-button>
      						<el-button class="refreshBtn" type="info" @click="resetForm('dataForm')">重置</el-button>
      					</div>
      				</el-form-item>
      			</el-col>
      		  </el-row>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column label="序号" type="index" width="50" align="center">
          <template slot-scope="scope">
            <span>{{(page - 1) * limit + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="taskCode" label="任务发布编号" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="publishName" label="发布方" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="taskType" label="任务大类" header-align="center" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ $getDictLabel("taskType", scope.row.taskType) }}
          </template>
        </el-table-column>
        <el-table-column prop="budget" label="预算金额(元)" header-align="center" align="center"></el-table-column>
        <el-table-column prop="moneyType" label="币种" header-align="center" align="center">
          <template slot-scope="scope">
            人民币
          </template>
        </el-table-column>
        <el-table-column prop="status" label="任务状态" header-align="center" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
          			  <el-tag v-if="scope.row.status == 0" size="small" type="danger">草稿
          			  </el-tag>
          			  <el-tag v-if="scope.row.status == 1" size="small" type="warning">待审核
          			  </el-tag>
          			  <el-tag v-if="scope.row.status ==2" size="small">已审核
          			  </el-tag>
          			  <el-tag v-if="scope.row.status == 3" size="small" type="success">已完成
          			  </el-tag>
          			  <el-tag v-if="scope.row.status == 4" size="small" type="info">已关闭
          			  </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="updateDate" label="操作日期" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="childHandle(scope.row.id)">去接任务</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
	  background
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <task-accept v-if="accept" ref="acceptOrUpdate" @refreshDataList="getDataList"></task-accept>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import taskAccept from './task-accept'
import { addDynamicRoute } from '@/router'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      accept: false,
      mixinViewModuleOptions: {
        getDataListURL: '/sys/plat/task/pageForAccept?status=2',
        getDataListIsPage: true,
        exportURL: '/sys/plat/task/export'
      },
      daterange: null,
      dataForm: {
        publishName: '',
        startDate: '',
        endDate: '',
        budget1: '',
        budget2: '',
        taskType: ''
      }
    }
  },
  watch: {
    daterange (val) {
      if (val !== null) {
        this.dataForm.startDate = val[0]
        this.dataForm.endDate = val[1]
      } else {
        this.dataForm.startDate = ''
        this.dataForm.endDate = ''
      }
    }
  },
  components: {
    taskAccept
  },
  methods: {

	  formatStartTime (val) {
	    this.dataForm.startDate = val
	  },
	  formatEndTime (val) {
	    this.dataForm.endDate = val
	  },

	  resetForm (formName) {
	  	this.$refs[formName].resetFields()
	  	this.dataForm.budget1 = ''
	  	this.dataForm.budget2 = ''
	  	this.dataForm.startDate = ''
	  	this.dataForm.endDate = ''
	  },
    // 新增 / 修改
    acceptTaskHandle (id) {
      this.accept = true
      this.$nextTick(() => {
        this.$refs.acceptOrUpdate.dataForm.id = id
        this.$refs.acceptOrUpdate.init()
      })
    },
    childHandle (id) {
      this.$http
        .get('/sys/user/info')
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          // if(res.data.userStatus == 0){
          // 	return this.$message.error("个人身份未认证，请先扫码进行小程序认证！");
          // }
			  // 路由参数
			  const routeParams = {
            routeName: `${this.$route.name}__接任务`,
            title: `任务详情`,
            path: 'task/accept-info',
            params: {
				  id: id
            }
			  }
			  // 动态路由
			  addDynamicRoute(routeParams, this.$router)
	  })
    }
  },
  created () {
  }
}
</script>
<style lang='scss' scoped>
  .unitStyle1 {
    text-align: center;
    margin-right: 20px;
    font-size: 16px;
    color: #409EFF;
  }
</style>
